import { Injectable } from '@angular/core';
import { Polygon } from '../../components/workspace/objects/polygon';
import paper from 'paper';
import { WorkspaceProvider } from '../workspace';
import { WorkspaceType } from '../workspace_enums';
import { SettingsProvider } from '../settings';
import { Class } from '../class';

@Injectable()
export class PolygonFactoryProvider {
    constructor(private workspaceProvider: WorkspaceProvider, private settingsProvider: SettingsProvider) {}

    public createPolygon(children: paper.Path[] = [], neuralaClass: Class | null = null): Polygon {
        const defaultNoClassColor = this.getDefaultNoClassColor();

        return new Polygon({
            children,
            neuralaClass: neuralaClass && neuralaClass.id ? neuralaClass : null,
            fullySelected: false,
            defaultNoClassColor
        });
    }

    private getDefaultNoClassColor() {
        const workspaceType = this.workspaceProvider.getCurrentWorkspaceType();
        switch (workspaceType) {
            case WorkspaceType.ObjectDetection:
                return this.settingsProvider.get('detection.workspace.defaultBoxColor');
            case WorkspaceType.Segmentation:
                return this.settingsProvider.get('segmentation.workspace.noClassColor');
            default:
                return '#FFFFFF';
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/workspace/polygon-factory.ts